import { render, staticRenderFns } from "./AgentBalanceLogs.vue?vue&type=template&id=010d0eda&"
import script from "./AgentBalanceLogs.vue?vue&type=script&lang=ts&"
export * from "./AgentBalanceLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AgentBalanceLogs.vue"
export default component.exports